// 客户端错误边界包装组件
"use client"

import { usePathname } from "next/navigation"
import type React from "react"
import ErrorBoundary from "./error-boundary"

interface ClientErrorBoundaryWrapperProps {
	children: React.ReactNode
}

export function ClientErrorBoundaryWrapper({
	children,
}: ClientErrorBoundaryWrapperProps) {
	const pathname = usePathname()

	return <ErrorBoundary key={pathname}>{children}</ErrorBoundary>
}
